module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_juha-aaltonen_A4.63d8a21.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_juha-aaltonen_A4.pdf
// module id = Fnlc
// module chunks = 22